import { useFeatureFlag } from "services/Flags";

import { replacePersonaPlaceholders } from "../adonis.helpers";
import { useAdonisChat } from "../AdonisChatProvider/AdonisChatProvider";

import aiIcon from "./../assets/ai-icon.webp";
import { getPersonaImage } from "./../assets/getPersonaImage";

type AdonisDynamicCTABannerProps = {
  readonly onClick: () => void;
  readonly onClose?: () => void;
};

const AdonisDynamicCTABanner = ({
  onClick,
  onClose,
}: AdonisDynamicCTABannerProps) => {
  const adonisDynamicCTAText = useFeatureFlag("adonisDynamicCTAText");
  const { persona } = useAdonisChat();

  const defaultText = {
    line1: "Find the Right",
    line2: `Treatment with {Name}`,
  };

  const text = adonisDynamicCTAText
    ? {
        line1: replacePersonaPlaceholders(
          adonisDynamicCTAText.line1 || defaultText.line1,
          persona
        ),
        line2: replacePersonaPlaceholders(
          adonisDynamicCTAText.line2 || defaultText.line2,
          persona
        ),
      }
    : {
        line1: replacePersonaPlaceholders(defaultText.line1, persona),
        line2: replacePersonaPlaceholders(defaultText.line2, persona),
      };

  return (
    <button className="w-full cursor-pointer overflow-hidden" onClick={onClick}>
      <img
        className="absolute bottom-0 left-0 h-[100px] w-[108px] translate-y-[3px] object-contain"
        style={{ zIndex: 9999 }}
        src={getPersonaImage(persona?.name).clear}
        alt={persona.name ?? "Adonis"}
      />
      <div className="absolute bottom-0 left-0 flex w-full items-center justify-center overflow-hidden bg-[linear-gradient(250deg,_#D3B795_52.56%,_#FFF8F0_88.09%)] pt-[30%] [clip-path:ellipse(54%_80%_at_50%_100%)]">
        <div className="absolute left-[48%] top-1/2 flex w-full -translate-x-[47%] -translate-y-[40%] flex-col items-center justify-center text-center font-serif text-h3">
          <img className="mb-2 h-5 w-5" src={aiIcon} alt="Icon" />
          <h1 className="ml-7">
            {text.line1}
            <br />
            {text.line2}
          </h1>
        </div>
        <p
          className="absolute bottom-[1px] right-2 cursor-pointer border border-transparent text-[30px]"
          onClick={(e) => {
            e.stopPropagation();
            onClose?.();
          }}
        >
          &times;
        </p>
      </div>
    </button>
  );
};

export default AdonisDynamicCTABanner;
